<template>
    <div class="">
        <Arrows @changeComponent="changeComponent($event)" @arrowChangeComponent="arrowChangeComponent($event)" :leftText="leftText" :rightText="rightText" ref="Arrows"/>
        <PageBar @changeComponent="changeComponent($event)" ref="PageBar" />
        <NavText :sectionName="sectionName" ref="NavText" />
        <!-- <NavBar /> -->
        <Sim @changeNavText="changeNavText($event)"  @changeComponent="changeComponent($event)" :currentContent="currentContent"/>
        <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
        <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    </div>
</template>

<script>
import NavText from './NavText.vue';
// import NavBar from './NavBar.vue';
import Sim from './Sim.vue';
import Arrows from './Arrows.vue';
import PageBar from './PageBar.vue';
// import Content2Vue from './Content2.vue';

export default {
  name: 'Main',
  props: ['introComponent'],
  components: {
    'NavText': NavText,
    // NavBar, 
    Sim, 
    'Arrows': Arrows, 
    PageBar,
    'pageBar': PageBar
  },
  data() {
    return {
      sectionName: '',
      leftText: '',
      rightText: '',
      currentContent: '',
      thisCurrentNumber: '',
      contentNames: [
        'Intro',
        'Content',
        'Content2',
        'Content3'
      ]
    }
  },
  methods: {
    changeNavText($event) {
      this.sectionName = $event;
    },
    changeComponent($event) {
      //  alert(this.sectionName);
    //   console.log($event);
    //   this.currentComponent = $event;
    //   window.scrolwlTo(0, 0);
      // this.sectionName = $event;
      // console.log($event)
      // this.$emit('changeComponent', $event);
      var goToIndex = $event;
      if (goToIndex == this.thisCurrentNumber) {
        return;
      } else {
        this.thisCurrentNumber = goToIndex;
        var pageGoHere = this.contentNames[goToIndex];
        // console.log("Go to content name located at index: "+goToIndex);
        // console.log(pageGoHere);
        this.currentContent = pageGoHere;
        if (goToIndex == 1) {
          this.$refs.NavText.roundColor();
          this.$refs.PageBar.roundColor();
          this.$emit('changeNavBarColor', goToIndex);
          this.leftText = "Home";
          this.rightText = "Flat Earth";
        }
        if (goToIndex == 2) {
          this.$refs.NavText.flatColor();
          this.$refs.PageBar.flatColor();
          this.$emit('changeNavBarColor', goToIndex);
          this.leftText = "Round Earth";
          this.rightText = "Hollow Earth";
        }
        if (goToIndex == 3) {
          this.$refs.NavText.hollowColor();
          this.$refs.PageBar.hollowColor();
          this.$emit('changeNavBarColor', goToIndex);
          this.leftText = "Flat Earth";
          this.rightText = "Home";
        }
      }
    },
    arrowChangeComponent($event) {
      // console.log($event);
      var goToIndex = this.thisCurrentNumber + $event;
      this.thisCurrentNumber = goToIndex;

      if (goToIndex < 1 || goToIndex > 3) {
        this.$emit('changeComponent', 'Intro');
        this.$emit('changeNavBarColor', 0);
        // console.log("Go to Intro");
      } else {
        // console.log("Go to content name located at index: "+goToIndex);
        var arrowGoHere = this.contentNames[goToIndex];
        // console.log(arrowGoHere);
        this.currentContent = arrowGoHere;
        if (goToIndex == 1) {
          this.$refs.PageBar.roundColor();
          this.$refs.NavText.roundColor();
          this.$emit('changeNavBarColor', goToIndex);
          this.leftText = "Home";
          this.rightText = "Flat Earth";
          // this.$refs.Arrows.roundColor();
        }
        if (goToIndex == 2) {
          this.$refs.PageBar.flatColor();
          this.$refs.NavText.flatColor();
          this.$emit('changeNavBarColor', goToIndex);
          this.leftText = "Round Earth";
          this.rightText = "Hollow Earth";
          // this.$refs.Arrows.flatColor();
        }
        if (goToIndex == 3) {
          this.$refs.PageBar.hollowColor();
          this.$refs.NavText.hollowColor();
          this.$emit('changeNavBarColor', goToIndex);
          this.leftText = "Flat Earth";
          this.rightText = "Home";
          // this.$refs.Arrows.hollowColor();
        }
      }
      // this.$emit('changeComponent', $event);
    },
    // contentListener($event) {
      // console.log("Ignore this event: "+$event);
      // return;
      // this.currentContent = $event;
      // console.log(this.contentNames[1]);
      // var thisPage = this.contentNames[$event];
      // console.log(thisPage);
      // console.log(this.contentNames[1]);
    // }
  },
  mounted() {
      window.scrollTo(0, 0);
      // console.log(this.introComponent);
      var goHere = this.contentNames[this.introComponent];
      // console.log(goHere);
      if (this.introComponent == 1) {
        this.$refs.PageBar.roundColor();
        this.$refs.NavText.roundColor();
        this.$emit('changeNavBarColor', this.introComponent);
        this.leftText = "Home";
        this.rightText = "Flat Earth";
      }
      if (this.introComponent == 2) {
        this.$refs.PageBar.flatColor();
        this.$refs.NavText.flatColor();
        this.$emit('changeNavBarColor', this.introComponent);
        this.leftText = "Round Earth";
        this.rightText = "Hollow Earth";
      }
      if (this.introComponent == 3) {
        this.$refs.PageBar.hollowColor();
        this.$refs.NavText.hollowColor();
        this.$emit('changeNavBarColor', this.introComponent);
        this.leftText = "Flat Earth";
        this.rightText = "Home";
      }
      this.currentContent = goHere;
      this.thisCurrentNumber = this.introComponent;
      // console.log("You are currently on index: "+this.thisCurrentNumber);
      // this.currentContent = this.introComponent;
      // this.currentContent = this.contentNames[1];
      // console.log(this.contentNames[1]);
      // this.currentContent = 
  }
}
</script>

<style>
    .bridgeDot {
        height: 24px;
        width: 24px;
        border-radius: 50%;
        background-color: black;
        margin-bottom: 4px;
        margin-left: 4px;
        float: right;
    }

    .bRound {
        background-color: #2D7BE5;
    }

    .bFlat {
        background-color: #459300;
    }

    .bHollow {
        background-color: #D2841A;
    }

</style>
